export const APP_NAME = '@plataforma-fluency-b2b'
export const NODE_ENV = process.env.REACT_APP_NODE_ENV
export const API_BASE_URL = process.env.REACT_APP_BASE_URL
export const API_BASE_URL_AWARI = process.env.REACT_APP_BASE_URL_AWARI
export const API_BASE_URL_WHITELABEL = process.env.REACT_APP_BASE_URL_WHITELABEL
export const AMPLITUDE_EXPERIMENT_KEY = process.env.REACT_APP_AMPLITUDE_EXPERIMENT_KEY
export const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY
export const AMPLITUDE_URL = process.env.REACT_APP_AMPLITUDE_URL
